import { patchState, signalStore, withHooks, withMethods } from "@ngrx/signals";
import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, setPending, withRequestStatus } from "../extensions/request-status.feature";
import { inject } from "@angular/core";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { AchievementBackofficeViewModel } from "@playcharge/common/models/backend/achievements/backoffice/achievement-backoffice-view-model";
import { ApiAchievementsService } from "../../services/api-achievements.service";

export type AchievementsStore = InstanceType<typeof AchievementsStore>;

export const AchievementsStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<AchievementBackofficeViewModel>(),
    withRequestStatus(),
    withMethods((store, apiAchievementsService = inject(ApiAchievementsService)) => ({
        setAchievement(achievement: AchievementBackofficeViewModel): void {
            patchState(store, setEntity(achievement));
        },
        loadAchievements: rxMethod<void>(
            pipe(
                tap(() => patchState(store, setPending())),
                switchMap(() => {
                    return apiAchievementsService.getAll().pipe(
                        tap((achievements) => {
                            patchState(store, setAllEntities(achievements));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks((store) => ({
        onInit: () => {
            store.loadAchievements();
        },
    })),
);
